
import 'babel-polyfill'
import Vue from "vue/dist/vue.esm"
import Vuex from "vuex"
import axios from 'packs/axios'
import qs from 'qs'
import AbstractRest from "stores/abstract_rest"
import createPersistedState from 'vuex-persistedstate'

Vuex.Store.prototype.$http = axios
Vuex.Store.prototype.$qs = qs
Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    message: "初期メッセージ",
    'SalesPeople/fetch': '',
    'Agencies/fetch': '',
    'FinalBookShopAgencies/fetch': '',
    'AcceptingOrderRoutes/fetch': ''
  },
  modules: {
    Books: AbstractRest,
    AcceptingOrderRoutes: AbstractRest,
    DeliverTypes: AbstractRest,
    SalesPeople: AbstractRest,
    FinalBookShopAgencies: AbstractRest,
    FinalBookShops: AbstractRest,
    Agencies: AbstractRest,
    AcceptingOrder: AbstractRest,
    AcceptingDraftOrder: AbstractRest,
    ManipulatedOrder: AbstractRest,
    Users: AbstractRest,
  },
  plugins: [
    createPersistedState({
      paths: [
        'SalesPeople', 'SalesPeople/fetch',
        'Agencies', 'Agencies/fetch',
        'FinalBookShopAgencies', 'FinalBookShopAgencies/fetch',
        'AcceptingOrderRoutes', 'AcceptingOrderRoutes/fetch'
      ]
    })
  ],
  getters: {
    cacheActionNames() {
      return [
               'SalesPeople/fetch',
               'Agencies/fetch',
               'FinalBookShopAgencies/fetch',
               'AcceptingOrderRoutes/fetch'
             ]
    }
  }
})

export default store